module.exports = __webpack_public_path__ + "img/ic-sydw-point.67b75a33.png";